import { P2GAlert, P2GText } from '@parcel2go/core-ui';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { toDisplayCurrency } from '~/lib/prices';
import { Currency } from '~/lib/types/basket-types';

type props = {
  currency: Currency;
  count: number;
  value: number;
};

const ParcelTotal = ({ currency, count, value }: props) => {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  return (
    <P2GAlert type="info" style={{ backgroundColor: 'white' }}>
      <P2GText variant="body1">
        <Trans
          t={t}
          i18nKey="PARCEL_DIMENSION_PRICE"
          defaults={'The total value of your <0>{{count}}</0> parcels is <0>{{price}}</0>.'}
          values={{
            price: toDisplayCurrency(currency, value || 0),
            count: count
          }}
          components={[<P2GText fontWeight="bold" />]}
        />
      </P2GText>
    </P2GAlert>
  );
};

export default ParcelTotal;
